import { getDateRange } from '@modules/common/components/DateRangePicker/helpers';
import { DateTimeRange } from '@modules/common/components/DateRangePicker/types';
import { TimeUnit } from 'generated/graphql';

export const getTimeBucketCountFromAggregatePeriod = (
  aggregatePeriod: TimeUnit,
  dateRange: DateTimeRange,
): number => {
  const [startDate, endDate] = getDateRange(dateRange);

  if (!startDate || !endDate) {
    return 0;
  }

  switch (aggregatePeriod) {
    case TimeUnit.Day:
      return endDate.diff(startDate, 'day');
    case TimeUnit.Week:
      return endDate.diff(startDate, 'week');
    case TimeUnit.Month:
      return endDate.diff(startDate, 'month');
    default:
      return 0;
  }
};
